@use "~theme/typography";

.reload {
  @include typography.caption;
  @include typography.light-link;
  border: none;
  padding: 0;
  color: var(--brand-indigo);
}
